module.exports = __webpack_public_path__ + "img/Alien_symbol_3.597f0207.png";